import { Button, Form, Image, Input, Typography } from "antd";
import React, { useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { translation } from "../../../../i18n/translationConstant";
import { UserLoginSuccessResponse } from "../../../../Models/Response/Authentication/Otp";
import {
  sendOtp,
  verifyOtp,
} from "../../../../Services/AuthenticationServices/AuthenticationServices";
import { LoginSignupFormType } from "../../../../Utils/Constants/loginSignupFormTypes";
import { Redirection } from "../../../../Utils/Constants/redirection";
import PinInputComponent from "../../../Common/Components/PinInput";
import UserIdentification from "../../../Identifiers/UserIdentification";
import ForgotPassword from "../ForgotPassword";
import UserInformation from "../UserInformation";
import "./index.css";
interface ILoginSignupFormProps
  extends React.PropsWithChildren,
    WithTranslation {
  formType: string;
  formSubmit: (values: any) => void;
  buttonSubSectionText: string;
  buttonSubSectionButton: string;
  className?: string;
  subButtonClick: () => void;
  buttonText: string;
  isLoginWithPin?: (is: boolean) => void;
  phoneNumber?: string;
  isVuaIdDisabled?: boolean;
}

enum FormType {
  LOGIN = "LOGIN",
  CreateAccount = "Create Account",
}

const LoginSignupForm: React.FC<ILoginSignupFormProps> = ({
  t,
  className,
  isLoginWithPin,
  children,
  formType,
  formSubmit,
  buttonSubSectionButton,
  buttonSubSectionText,
  buttonText,
  subButtonClick,
  phoneNumber,
  isVuaIdDisabled,
}) => {
  const [isLoginWithPinState, setIsLoginWithPin] = useState(true);
  const [form] = Form.useForm();
  const [token, setToken] = useState("");
  const [otpUniqueID, setOTPUniqueId] = useState("");
  const [mobile, setmobile] = useState("");
  const loading: boolean = useSelector(
    (state: any) => state.loader.searchLoader
  );
  const [visible, setVisibility] = useState(false);
  const [isAddIdentifierVerification, setVerification] = useState(false);

  const onMobileChange = (e: any) => {
    if (e.target.value[0] === "0") {
      e.target.value = e.target.value.substring(1);
    }
    e.target.value = e.target.value.replace(/[^0-9]/gi, "");
  };

  let disableInputPhoneNumber = false;
  if (!!phoneNumber && phoneNumber.length === 10) {
    form.setFieldsValue({ phoneNumber });
    disableInputPhoneNumber = true;
  }

  const loginWithPin = () => {
    setIsLoginWithPin(!isLoginWithPinState);

    // tslint:disable-next-line: no-unused-expression
    isLoginWithPin && isLoginWithPin(!isLoginWithPinState);
    if (isLoginWithPinState) {
      form.setFieldsValue({ pin: "" });
    }
  };

  const checkVuaId = (_: any, value: string) => {
    if (
      value &&
      value.length === 10 &&
      Number(value) &&
      value !== form.getFieldValue(LoginSignupFormType.phoneNumber)
    ) {
      return Promise.reject(new Error(t(translation.errofCustomValidation)));
    }
    return Promise.resolve();
  };

  const setVuaIdAsMobileNumber = (change: any) => {
    const phoneNumberField = change.filter(
      (c: any) => c.name.toString() === LoginSignupFormType.phoneNumber
    )[0];
    const vuaIdField = change.filter(
      (c: any) => c.name.toString() === LoginSignupFormType.vuaId
    )[0];
    // tslint:disable-next-line: no-unused-expression
    phoneNumberField &&
      phoneNumberField.touched &&
      phoneNumberField.value &&
      phoneNumberField.value.length === 10 &&
      !vuaIdField &&
      form.setFieldsValue({ vuaId: phoneNumberField.value });
  };

  const onCancel = () => {
    setVisibility(false);
    setVerification(false);
  };

  const onIdentifierEntered = (iNumber: any) => {
    setmobile(iNumber.value);
    sendOtp({ phoneNumber: iNumber.value })
      .then((res) => res.data)
      .then((res) => {
        setOTPUniqueId(res);

        setVerification(true);
      });
  };

  const onOTPSubmit = (otp: string, identifierNumber: any) => {
    setToken("");

    verifyOtp({
      phone_number: mobile,
      grant_type: "password",
      code: otp,
      otpUniqueID,
    })
      .then((res) => res.data)
      .then((res: UserLoginSuccessResponse) => {
        form.resetFields();
        setVisibility(false);
        setVerification(false);
        setToken(res.access_token);
      });
  };

  return (
    <>
      {token && <ForgotPassword token={token} />}
      <UserIdentification
        handleCancel={onCancel}
        identifierEntered={onIdentifierEntered}
        isAddIdentifierVerification={isAddIdentifierVerification}
        onOTPSubmit={onOTPSubmit}
        visible={visible}
        label={"Enter Mobile Number"}
        multipleIdentifiers={false}
        isForgotPassword={true}
        mobileNumber={mobile}
        entityIdentifiers={[]}
      />
      <div className="detailsForm flexCommonCss">
        <Form
          form={form}
          className="form"
          name="basic"
          onFinish={formSubmit}
          autoComplete="off"
          onFieldsChange={setVuaIdAsMobileNumber}
          scrollToFirstError={true}
        >
          <div className={`${className} flexCommonCss formBodyInput`}>
            {localStorage.getItem("redirect") && (
              <Image
                preview={false}
                width={70}
                height={70}
                src={
                  localStorage.getItem("fiuId") &&
                  process.env.REACT_APP_LOGO_BASE_URL
                    ? `${
                        process.env.REACT_APP_LOGO_BASE_URL
                      }${localStorage.getItem("fiuId")}.png`
                    : ""
                }
                fallback={Redirection.FallBackUrl}
              />
            )}
            <Typography.Text className="formTypeText">
              {formType === FormType.LOGIN
                ? t(translation.lblLogin)
                : t("Lets get Started")}
            </Typography.Text>

            <Typography.Text className="formTypeSubText">
              {formType === FormType.LOGIN
                ? t("Please enter your valid data in order to Login.")
                : t(
                    "Please enter your valid data in order to create an account."
                  )}
            </Typography.Text>
            <Form.Item
              className="inputCss formItemMarginBotton"
              name={LoginSignupFormType.phoneNumber}
              rules={[
                {
                  required: true,
                  message: t(translation.errorRequiredPhoneNumber),
                },
                {
                  len: 10,
                  message: t(translation.errorInvalidPhoneNumber),
                },
              ]}
            >
              <Input
                id="mobile"
                type="tel"
                onInput={onMobileChange}
                autoComplete="off"
                maxLength={10}
                placeholder={t(translation.lblMobileNumber)}
                disabled={disableInputPhoneNumber}
              />
            </Form.Item>
            {isLoginWithPinState && formType === FormType.LOGIN && (
              <>
                <PinInputComponent className="inputCss1" />
                <Typography.Text
                  className="forgotPin"
                  // tslint:disable-next-line: jsx-no-lambda
                  onClick={() => setVisibility(true)}
                >
                  {t(translation.lblForgotPassword)}
                </Typography.Text>
              </>
            )}

            {formType === FormType.CreateAccount && (
              <UserInformation
                vuaIdValidator={checkVuaId}
                vuaId={!!phoneNumber ? `${phoneNumber}` : ""}
                isVuaIdDisabled={isVuaIdDisabled}
                form={form}
              />
            )}
            {children}
          </div>
          <div className="flexCommonCss formFooter">
            {formType === FormType.LOGIN && (
              <Typography.Text className="loginPin" onClick={loginWithPin} style={{color: 'var(--hintSecondaryColor)'}}>
                {!isLoginWithPinState
                  ? t(translation.lblLoginWithPin)
                  : t(translation.lblLoginWithOTP)}
              </Typography.Text>
            )}
            <Form.Item className="otpButton formItemMarginBotton">
              <Button
                loading={loading}
                className="commonButtonBackground primaryButton formItemButton"
                htmlType="submit"
              >
                {(!isLoginWithPinState && formType === FormType.LOGIN) ||
                formType === FormType.CreateAccount
                  ? buttonText
                  : t(FormType.LOGIN)}
              </Button>
            </Form.Item>
            {!disableInputPhoneNumber && (
              <div className="dontHaveAccountFooter">
                <Typography.Text className="donthaveaccountText primaryButton">
                  {buttonSubSectionText}
                </Typography.Text>

                <Button
                  className="primaryButton"
                  onClick={subButtonClick}
                  id="createAccountButton"
                  type="text"
                >
                  {buttonSubSectionButton}
                </Button>
              </div>
            )}
          </div>
        </Form>
      </div>
    </>
  );
};

export default withTranslation()(LoginSignupForm);
